import React from "react";

import { Divider, Label } from "./OrDivider.styled";

const OrDivider = ({ language }) => {
    const text = language?.tracker_detail?.or ?? "or";
    return (
        <Divider role="separator" aria-label={text}>
            <Label>{text}</Label>
        </Divider>
    );
};

export default OrDivider;
